import React from 'react'
import { useParams } from 'react-router-dom'
import Error from 'components/error'
import ApolloDataView from 'components/apollo-data-view'
import StudentListView from './student-list-view'
import LoadingView from 'pages/pga-coach/students/loading-view'
import { useGetCoachingCenterStudents } from '../api-hooks'
import {
  useOwnedCoachingCenters,
  OwnedCoachingCentersProvider,
} from '../dropdown/coaching-center-list-dropdown'
import CoachingCenterPageHeader from 'components/page-header/coaching-center-page-header'
import { processStudentsData } from '../utils'
import { useAuth } from 'lib/auth'

const CoachingCenterStudentsListBody = () => {
  const { slug } = useParams()
  const {
    ownedCoachingCenters,
    loading: affiliationsLoading,
    error: affiliationsError,
  } = useOwnedCoachingCenters()
  const hasOwnedSlug = ownedCoachingCenters.some(
    academy => academy.slug === slug,
  )
  const { loading, error, data } = useGetCoachingCenterStudents({
    academySlug: hasOwnedSlug ? slug : undefined,
  })

  const enrolledStudents = data ? processStudentsData(data.academyStudents) : []

  let studentsView = null
  if (affiliationsError) {
    studentsView = <Error error={affiliationsError} />
  } else if (!affiliationsLoading && ownedCoachingCenters.length === 0) {
    studentsView = <StudentListView key="no-academy" students={[]} />
  } else if (hasOwnedSlug) {
    studentsView = (
      <ApolloDataView error={error} loading={loading} data={enrolledStudents}>
        {{
          errorView: <Error />,
          emptyView: <StudentListView key={slug} students={[]} />,
          loadingView: <LoadingView />,
          dataView: students => (
            <StudentListView key={slug} students={students} />
          ),
        }}
      </ApolloDataView>
    )
  }

  return (
    <CoachingCenterPageHeader title="Students">
      {studentsView}
    </CoachingCenterPageHeader>
  )
}

const CoachingCenterStudentsList = () => {
  const { user } = useAuth()

  if (!user.isAcademyOwner) {
    return <Error displayErrorType="page" />
  }

  return (
    <OwnedCoachingCentersProvider>
      <CoachingCenterStudentsListBody />
    </OwnedCoachingCentersProvider>
  )
}

export default CoachingCenterStudentsList
